import { SVGProps } from 'react'

export const CliIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.19996 10.58L10.08 13.4601L7.1999 16.3401M12.96 16.34L16.8 16.34M11.9999 22.1V22.1C15.3602 22.1 17.0404 22.1 18.3238 21.4461C19.4528 20.8708 20.3707 19.9529 20.9459 18.824C21.5999 17.5405 21.5999 15.8603 21.5999 12.5V12.5C21.5999 9.13971 21.5999 7.45956 20.9459 6.17608C20.3707 5.04711 19.4528 4.12923 18.3238 3.55399C17.0404 2.90003 15.3602 2.90003 11.9999 2.90003V2.90003C8.63959 2.90003 6.95943 2.90003 5.67596 3.55399C4.54699 4.12923 3.6291 5.04711 3.05386 6.17608C2.3999 7.45955 2.3999 9.13971 2.3999 12.5V12.5C2.3999 15.8603 2.3999 17.5405 3.05386 18.824C3.6291 19.9529 4.54698 20.8708 5.67596 21.4461C6.95943 22.1 8.63958 22.1 11.9999 22.1Z"
      stroke="currentColor"
      strokeWidth="1.35"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
